import Attendance from "./AttendanceComponents";
import LeaveComponent from "./LeavesComponents";

export default {
  LeaveComponent,
  Attendance
}